import { render } from "./NotFound.vue?vue&type=template&id=3555385b"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=3555385b&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__